"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SaveIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.75 0A1.75 1.75 0 000 1.75v10.5C0 13.216.784 14 1.75 14h10.5A1.75 1.75 0 0014 12.25V6.782a3.5 3.5 0 00-1.126-2.571L9.318.928A3.5 3.5 0 006.944 0H1.75zm8.363 5.689a.656.656 0 00-.976-.878L5.622 8.716l-.827-.689a.656.656 0 00-.84 1.008l1.798 1.499 4.36-4.845z",
    clipRule: "evenodd"
  })))
});
SaveIcon.displayName = 'SaveIcon';
var _default = exports.default = SaveIcon;